import React from 'react';
import {fetchUtils, Button, SimpleForm, Filter, BooleanInput, required, Toolbar, SaveButton,
  DateField, Edit, Create, List, Datagrid, TextField, TextInput, SelectArrayInput, FormDataConsumer,
  ReferenceArrayInput, AutocompleteArrayInput} from 'react-admin';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
import ReportScheduler from './components/ReportScheduler';

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/adViewability_report';

const choicesSizes = [
  { id: '300x250', name: '300x250' },
  { id: '728x90',  name: '728x90' },
  { id: '300x600', name: '300x600' },
  { id: '160x600', name: '160x600' },
  { id: '120x600', name: '120x600' },
  { id: '970x90',  name: '970x90' },
  { id: '970x250', name: '970x250' },
  { id: '970x66',  name: '970x66' },
  { id: '300x1050', name: '300x1050' },
  { id: '320x50',  name: '320x50' },
  { id: '300x50',  name: '300x50' },
  { id: '320x100', name: '320x100' },
  { id: '336x280', name: '336x280' }
];
const choicesDevices = [
  { id: 'Computer', name: 'Desktop' },
  { id: 'Mobile', name: 'Mobile' },
  { id: 'Tablet', name: 'Tablet' }
]

let choicesShow = (permissions) => {
  const baseChoices = [
    { id: 'publisher', name: 'Publisher' },
    { id: 'site', name: 'Site' },
    { id: 'placement', name: 'Placement' },
    { id: 'domain', name: 'Domain' },
    { id: 'device', name: 'Device' },
    { id: 'size', name: 'Size' },
    { id: 'divid', name: 'Div ID'}
  ];

  const adminChoices = baseChoices.concat(
    [
      { id: 'seller_type', name: 'Seller Type'},
      { id: 'avg_revenue', name: 'Revenue'},
      { id: 'avg_net_revenue', name: 'Net Revenue'},
      { id: 'avg_impressions', name: 'Impressions'},
      { id: 'avg_adrequests', name: 'Ad Requests'},
      { id: 'avg_adresponses', name: 'Ad Responses'}
    ]
  )

  return permissions.role === 'admin' ? adminChoices : baseChoices;
}

const AdViewabilityTitle = ({ record }) => {
  return <span>Ad Viewability Report {record ? `"${record.report_name}"` : ''}</span>;
};
const AdViewabilityFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);
export const AdViewabilityReportList = (props) => (
  <List {...props} title="Ad Viwability Reports" perPage={25} bulkActionButtons={false} filters={<AdViewabilityFilter />} 
  exporter={false} >
    <Datagrid rowClick="edit">
      <TextField source="report_name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
    </Datagrid>
  </List>
);
class CustomToolbar extends React.Component {
  state = {
  }
  constructor(props) {
    super(props);
    this.parent = props.parent;
  }
  fetchData() {
    function formDataFields(formData, fields) {
      const buf = [];
      for(let i in fields) {
        let field = fields[i];
        if (formData[field] && formData[field].length>0) {
          formData[field].map(x => buf.push(`${field}=${x}`));
        }
      }
      return buf.length>0 ? `&${buf.join('&')}` : '';
    }
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    this.parent.setState({loading: true, total: '---'});
    let url = `${BASE_URL}?${show}`+
    `${formDataFields(formData, ['publisher_id', 'placement_id', 'site_id', 'domain', 'device', 'size', 'divid'])}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then(({ headers, json }) => (
      this.parent.setState({data: json.data, loading: false, total: json.total})
    ));
  }
  handleSearch = () => {
    this.fetchData();
  }

  render() {
    return <Toolbar>
      <SaveButton style={{marginRight: '25px'}} variant='contained' 
        color='primary' disabled={this.props.parent.state.loading} {...this.props} />
      <br />
      <Button label='Run Report' onClick={this.handleSearch} props={this} variant='contained' color='primary' 
        startIcon={<RunReportIcon />} style={{marginRight: '5px', padding: '7px', width: '160px'}} 
        disabled={this.props.parent.state.loading} />
      <br />
      {this.parent.props.formType==='edit' &&
        <span>
        <DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
        <TextField source="updated_name" label="" style={{ padding: '10px' }} />
        </span>
      }
    </Toolbar>
  }
};
let formData = {};
function setFormData(formdata) {
  formData = formdata;
}
class AdViewabilityForm extends React.Component {
  render() {
    return (
      <SimpleForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
        <TextInput source="report_name" label="Report Name" style={{ width: '400px' }} validate={required()} />
        <FormDataConsumer>
          {({ formData }) => setFormData(formData) }
        </FormDataConsumer>
        <div style={{ width: '100%', overflow: 'hidden' }}>
          <div style={{ float: 'left'}}>
            <SelectArrayInput label="Show"
            source="show"
            choices={choicesShow(this.props.permissions)}
            style={{ width: '400px' }}
            disabled={this.props.parent.loading} />
          </div>
        </div>
        <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">     
          <div style={{flex: 1}}>
            <ReferenceArrayInput
              source="publisher_id" 
              label="Publishers" 
              reference="publishers"
              basePath="publishers"
              perPage={15} 
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ search_name: searchText })}
              disabled={this.props.parent.loading}>
              <AutocompleteArrayInput disabled={this.props.parent.loading} 
                optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                optionValue="code"
                fullWidth
              />
            </ReferenceArrayInput>
          </div>
          
          <div style={{flex: 1}}>
            <ReferenceArrayInput
              source="site_id"
              label="Sites"
              reference="sites"
              basePath="sites"
              perPage={15} 
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ search_name: searchText })}
              disabled={this.props.parent.loading}>
              <AutocompleteArrayInput disabled={this.props.parent.loading} 
                optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                optionValue="code"
                fullWidth
              />
            </ReferenceArrayInput>
          </div>

          <div style={{flex: 1}}>
            <ReferenceArrayInput
              source="placement_id"
              label="Placement"
              reference="placements"
              basePath="placements"
              perPage={15} 
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ search_name: searchText })}
              disabled={this.props.parent.loading}>
              <AutocompleteArrayInput disabled={this.props.parent.loading} 
                optionText={x => (x && x.code) ? `${x.name} (${x.code})` : ''}
                optionValue="code"
                fullWidth
              />
            </ReferenceArrayInput>
          </div>
        </div>
        <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3"> 
          <div style={{flex: 1}}>
            <ReferenceArrayInput
              source="domain"
              label="Domains"
              reference="adViewability_domains"
              basePath="adViewability_domains"
              perPage={15} 
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ search_name: searchText })}
              disabled={this.props.parent.loading}>
              <AutocompleteArrayInput disabled={this.props.parent.loading}
                optionText="name"
                optionValue="code"
                fullWidth
              />
            </ReferenceArrayInput>
          </div>

          <div style={{flex: 1}}>
            <SelectArrayInput label="Devices"
              source="device" 
              choices={choicesDevices} 
              disabled={this.props.parent.loading}
              fullWidth
              />
          </div>

          <div style={{flex: 1}}>
            <SelectArrayInput label="Ad Sizes" 
              source="size" 
              choices={choicesSizes} 
              disabled={this.props.parent.loading}
              fullWidth
              />
          </div>

          <div style={{flex: 1}}>
            <ReferenceArrayInput
              source="divid"
              label="Div ID"
              reference="adViewability_divids"
              basePath="adViewability_divids"
              perPage={15} 
              sort={{ field: 'name', order: 'ASC' }}
              filterToQuery={searchText => ({ search_name: searchText })}
              disabled={this.props.parent.loading}>
              <AutocompleteArrayInput disabled={this.props.parent.loading} 
                optionText="name"
                optionValue="code"
                fullWidth
                />
            </ReferenceArrayInput>
          </div>
        </div>
        <ReportScheduler/>
      </SimpleForm>
    )
  }
}
let BASE_COLUMNS = [
  { name: 'Publisher', selector: 'publisher_name', sortable: true, cell: row => <span>{ `${row.publisher_name} (${row.publisher_id})` }</span> },
  { name: 'Site', selector: 'site_name', sortable: true, cell: row => <span>{ `${row.site_name} (${row.site_id})` }</span> },
  { name: 'Placement', selector: 'placement_name', sortable: true, cell: row => <span>{ row.placement_name ? `${row.placement_name} (${row.placement_id})` : '-' }</span> },
  { name: 'Domain', selector: 'domain', sortable: true, cell: row => <span>{ row.domain }</span> },
  { name: 'Device', selector: 'device', sortable: true, cell: row => <span>{ `${row.device?row.device.toUpperCase():'NA'}` }</span> },
  { name: 'Size', selector: 'adsize', sortable: true, cell: row => <span>{ row.adsize }</span> },
  { name: 'Div ID', selector: 'divid', sortable: true, cell: row => <span>{ row.divid ? `${row.divid}` : '-' }</span> },
  { name: 'Seller Type', selector: 'seller_type', sortable: true, cell: row => <span>{ row.seller_type }</span> },
  { name: '% Viewability', selector: 'viewability', sortable: true, cell: row => utils.formatDouble(row.viewability, ' ') },
  { name: '$ Revenue', selector: 'avg_revenue', sortable: true, cell: row => utils.formatDouble(row.avg_revenue, ' ') },
  { name: '$ Net Revenue', selector: 'avg_net_revenue', sortable: true, cell: row => utils.formatDouble(row.avg_net_revenue, ' ') },
  { name: 'Impressions', selector: 'avg_impressions', sortable: true, cell: row => utils.formatLong(row.avg_impressions, ' ') },
  { name: 'Ad Requests', selector: 'avg_adrequests', sortable: true, cell: row => utils.formatLong(row.avg_adrequests, ' ') },
  { name: 'Ad responses', selector: 'avg_adresponses', sortable: true, cell: row => utils.formatLong(row.avg_adresponses, ' ') }
];
let columns = [];

class AdViewablityUpsert extends React.Component {
  state = {
    data: [],
    loading: false,
    total: '---'
  };
  setState(obj) {
    if (obj.data && obj.data.length>0) {
      let keys = Object.keys(obj.data[0]);
      columns = BASE_COLUMNS.filter( item => { return keys.includes(item.selector) } );
      if (this.props.permissions.role !== 'admin') columns = columns.filter(item => item.selector.indexOf('revenue')<0);
    }
    super.setState(obj);
  }
  render() {
    const { data, loading, total } = this.state;
    return (
    <div>
      {this.props.formType === "edit" &&
        <Edit title={<AdViewabilityTitle />} {...this.props}>
          <AdViewabilityForm formType="edit" permissions={this.props.permissions} parent={this}/>
        </Edit>
      }
      {this.props.formType === "create" &&
        <Create title="Create Ad Viewability Report" {...this.props}>
          <AdViewabilityForm formType="create" permissions={this.props.permissions} parent={this}/>
        </Create>
      }
      <DataTable
        title={`${total} Matching Results (Daily Average)`}
        theme="dark"
        columns={columns}
        data={data}
        progressPending={loading}
        pagination
        fixedHeader
        dense
        paginationPerPage={30}
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        subHeader={!loading}
        subHeaderComponent={
          (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input type="text" id='search_box' label="Search"
            variant="outlined"
            style={{ margin: '5px' }}
            onChange={(target) => dataSupport.filterData(this)} />
            <CloudDownload
            label="Export"
            style={{ margin: '5px' }}
            color="action"
            onClick={() => dataSupport.exportData(this.state.data)}
            />
          </div>
          )
        }
      />
    </div>
    )
  }
}

export const AdViewabilityReportEdit = ({permissions, ...props}) => (
  <AdViewablityUpsert formType="edit" permissions={permissions} {...props} />
);

export const AdViewabilityReportCreate = ({permissions, ...props}) => (
  <AdViewablityUpsert formType="create" permissions={permissions} {...props} />
);